import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { cardMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';
import { useLang } from '@/i18n';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

export default function CardList() {
    const { locale } = useRouter();
    const cardData = cardMap[locale as keyof typeof cardMap] || cardMap.jp;
    const { t } = useLang('ecocreditsday.pageTabs.tabB.cardList');

    return (
        <div className={styles.cardList}>
            {['kr'].includes(locale as string) && <div className="title">{t('title')}</div>}
            <div className="card-box">
                <div className="card-list">
                    {cardData.map((item: Record<string, string | string[]>, i) => (
                        <div className="card-item" key={i}>
                            <EFPic className="card-img" name={item.src} />
                            <div className="card-text">{item.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
